<script setup>
const props = defineProps({
  type: {
    type: String,
    default: 'primary', // primary default tertiary info buy sell
  },
  size: {
    type: String,
    default: 'medium', // large 52  medium 40 small 32 tiny 24
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  btnClass: {
    type: String,
    default: '',
  },
})

const pattern = computed(() => {
  const { type, disabled, size } = props
  const val = 'rounded-full font-medium flex justify-center items-center'
  const objstyle = {
    primary: {
      default: 'bg-btnPrimary text-textOnBtn hover:bg-btnPrimaryHover cursor-pointer transition',
      disabled: 'bg-btnPrimaryDisable text-textOnBtn cursor-not-allowed',
    },
    default: {
      default: 'border border-btnPrimary text-textPrimary hover:border-btnPrimary hover:bg-btnSecondary cursor-pointer',
      disabled: 'border border-btnPrimaryDisable text-textPrimaryDisable  cursor-not-allowed',
    },
    tertiary: {
      default: 'bg-btnSecondary border border-border text-textPrimary cursor-pointer',
      disabled: 'bg-btnSecondaryDisable border border-borderDisable text-textPrimaryDisable cursor-not-allowed',
    },
    info: {
      default: 'text-staticBlack !px-0 cursor-pointer',
      disabled: 'text-staticBlackDisable cursor-not-allowed',
    },
    buy: {
      default: 'text-textOnBtn bg-green3 cursor-pointer',
      disabled: 'text-textOnBtn bg-green3Disable cursor-not-allowed',
    },
    sell: {
      default: 'text-textOnBtn bg-red3 cursor-pointer',
      disabled: 'text-textOnBtn bg-red3Disable cursor-not-allowed',
    },
    large: 'text-base px-4 h-[52px]',
    medium: 'text-sm px-4 h-10',
    small: 'text-sm px-2 h-8',
    tiny: 'text-xs px-2 h-6',
  }
  return `${val} ${objstyle[size]} ${disabled ? objstyle[type].disabled : objstyle[type].default} ${props.btnClass}`
})
</script>

<template>
  <button :class="pattern" :disabled="disabled">
    <svgo-common-btn-loading v-if="loading" class="w-4 h-4 me-2 animate-spin" />
    <slot />
  </button>
</template>
